/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import PropTypes from "prop-types";

import { Carousel } from "../basic/carousel.js";
import { wrapCollectionLayout } from "@quintype/components";
import { CollectionName } from "../atoms/collection-name/index.js";
import "./half-screen-slider.module.css";
import { getNumberOfStoriesToShow, isEager, getRowMetadata } from "../../utils";

function HalfImageSliderBase({ collection, stories = [], associatedMetadata, config, index }) {
  const pbAheadConfig = getRowMetadata(config, associatedMetadata);
  const { show_collection_name: collectionName = true } = pbAheadConfig;
  const storyCardConfig = {
    imageWidth: [400, 600]
  };

  return (
    <div styleName="container" className="wrapper" data-testid="half-image-component">
      {collectionName ? <CollectionName name={collection.name} config={config} section={collection} /> : null}
      <Carousel
        stories={stories}
        infinite={getNumberOfStoriesToShow(pbAheadConfig["number_of_stories_to_show"]) > 1}
        config={storyCardConfig}
        collection={collection}
        rtl={config["theme-attributes"]["language_direction"] === "right"}
        arrow={pbAheadConfig["show_arrows"]}
        collectionName={pbAheadConfig["show_collection_name"]}
        numberOfStoriesToShow={getNumberOfStoriesToShow(pbAheadConfig["number_of_stories_to_show"]) || undefined}
        dot={pbAheadConfig["enable pagination - dot or dash"]}
        associatedMetadata={pbAheadConfig}
        eager={isEager(index, true)}
      />
    </div>
  );
}

HalfImageSliderBase.propTypes = {
  collection: PropTypes.object,
  config: PropTypes.object,
  associatedMetadata: PropTypes.object,
  stories: PropTypes.array,
  index: PropTypes.number
};

export const HalfImageSlider = wrapCollectionLayout(HalfImageSliderBase);

HalfImageSlider.storyLimit = 12;
